export default {
	namespaced: true,
	state: {
		cache: {
			listaDeProdutos: [],
			listaDeContratos: [],
			listaDeVendas: []
		},
		venda: {
			id_vendedor: "",
			id_plano: "",
			id_produto: "",

			nome_vendedor: "",
			nome_produto: "",
			nome_plano: "",

			contratante: {
				nome: "",
				profissao: "",
				sexo: "",
				cpf: "",
				rg: "",
				rg_orgao_emissor: "",
				nascimento: "",
				indicado: "",
				contratante_associado: false
			},
			contatos: {
				whatsapp: "",
				telefone: "",
				celular: "",
				celular_2: "",
				dono_celular_2: "",
				email: ""
			},
			endereco: {
				cep: "",
				rua: "",
				numero: "",
				complemento: "",
				cidade: "",
				bairro: "",
				uf: ""
			},
			card: {},
			documentos: [],
			forma_pagamento: "",
			valor_adesao: 0,
			isento_adesao: false,
			associados: [],
			listaDocumentosApagar: [],
			nome_unidade: null,
			id_unidade: null,
			isCpfValid: null,
			validations: {
				DadosContratanteValid: null,
				ContatosValid: null,
				EnderecoValid: null,
				PagamentoAdesaoValid: null,
				PagamentoValid: null,
				CreditCardValidated: null,
				DocumentosValid: null,
				AssociadoValid: null
			}
		}
	},

	mutations: {
		setListaDeProdutos(state, payload) {
			state.cache.listaDeProdutos = payload;
		},
		setListaDeContratos(state, payload) {
			state.cache.listaDeContratos = payload;
		},
		setListaDeVendas(state, payload) {
			state.cache.listaDeVendas = payload;
		},
		editVenda(state, venda) {
			state.venda = {
				id_vendedor: venda.contrato.id_vendedor,
				id_plano: venda.contrato.id_plano,
				id_produto: venda.contrato.id_produto,

				nome_vendedor: venda.contrato.nome_vendedor,
				nome_produto: venda.contrato.nome_produto,
				nome_plano: venda.contrato.nome_plano,

				contratante: {
					nome: venda.contrato.nome,
					profissao: venda.contrato.profissao,
					sexo: venda.contrato.sexo,
					cpf: venda.contrato.cpf,
					rg: venda.contrato.rg,
					rg_orgao_emissor: venda.contrato.rg_orgao_emissor,
					nascimento: venda.contrato.nascimento,
					indicado: venda.contrato.indicado,
					contratante_associado: venda.contrato.contratante_associado
				},
				contatos: {
					whatsapp: venda.contrato.whatsapp,
					telefone: venda.contrato.telefone,
					celular: venda.contrato.celular,
					celular_2: venda.contrato.celular_2,
					dono_celular_2: venda.contrato.dono_celular_2,
					email: venda.contrato.email
				},
				endereco: {
					cep: venda.contrato.cep,
					rua: venda.contrato.rua,
					numero: venda.contrato.numero,
					complemento: venda.contrato.complemento,
					cidade: venda.contrato.cidade,
					bairro: venda.contrato.bairro,
					uf: venda.contrato.uf
				},
				card: {},
				documentos: venda.documentos.map(i => i.documento),
				forma_pagamento: venda.contrato.forma_pagamento,
				valor_adesao: venda.contrato.valor_adesao,
				forma_pagamento_adesao: venda.contrato.forma_pagamento_adesao,
				isento_adesao: venda.contrato.isento_adesao,
				associados: venda.associados,
				listaDocumentosApagar: [],
				isCpfValid: venda.isCpfValid,
				validations: {
					DadosContratanteValid: true,
					ContatosValid: true,
					EnderecoValid: true,
					PagamentoAdesaoValid: true,
					PagamentoValid: true,
					AssociadoValid: true,
					DocumentosValid: true
				}
			};
		},
		clearVenda(state) {
			state.venda = {
				id_vendedor: "",
				id_plano: "",
				id_produto: "",

				nome_vendedor: "",
				nome_produto: "",
				nome_plano: "",

				contratante: {
					nome: "",
					profissao: "",
					sexo: "",
					cpf: "",
					rg: "",
					rg_orgao_emissor: "",
					nascimento: "",
					indicado: "",
					contratante_associado: false
				},
				contatos: {
					whatsapp: "",
					telefone: "",
					celular: "",
					celular_2: "",
					dono_celular_2: "",
					email: ""
				},
				endereco: {
					cep: "",
					rua: "",
					numero: "",
					complemento: "",
					cidade: "",
					bairro: "",
					uf: ""
				},
				documentos: [],
				forma_pagamento: "",
				card: {},
				valor_adesao: 0,
				forma_pagamento_adesao: "",
				listaDocumentosApagar: [],
				isento_adesao: false,
				associados: [],
				isCpfValid: null,
				validations: {
					DadosContratanteValid: null,
					ContatosValid: null,
					EnderecoValid: null,
					PagamentoAdesaoValid: null,
					PagamentoValid: null,
					DocumentosValid: null,
					AssociadoValid: null
				}
			};
		},

		clearCardInfo(state) {
			state.venda.card = {};
		},

		// VENDAS
		setVendedorId(state, payload) {
			state.venda.id_vendedor = payload;
		},
		setProdutoId(state, payload) {
			state.venda.id_produto = payload;
		},
		setPlanoId(state, payload) {
			state.venda.id_plano = payload;
		},
		setVendedorNome(state, payload) {
			state.venda.nome_vendedor = payload;
		},
		setProdutoNome(state, payload) {
			state.venda.nome_produto = payload;
		},
		setPlanoNome(state, payload) {
			state.venda.nome_plano = payload;
		},

		// CONTRATANTE

		setContratanteNome(state, payload) {
			state.venda.contratante.nome = payload;
		},
		setContratanteSexo(state, payload) {
			state.venda.contratante.sexo = payload;
		},
		setContratanteProfissao(state, payload) {
			state.venda.contratante.profissao = payload;
		},
		setContratanteCpf(state, payload) {
			state.venda.contratante.cpf = payload;
		},
		setContratanteRg(state, payload) {
			state.venda.contratante.rg = payload;
		},
		setContratanteRgOrgaoEmissor(state, payload) {
			state.venda.contratante.rg_orgao_emissor = payload;
		},
		setContratanteNascimento(state, payload) {
			state.venda.contratante.nascimento = payload;
		},
		setContratanteIndicado(state, payload) {
			state.venda.contratante.indicado = payload;
		},
		setContratanteAssociado(state, payload) {
			state.venda.contratante.contratante_associado = payload;
		},

		// CONTATOS

		setContatosWhatsapp(state, payload) {
			state.venda.contatos.whatsapp = payload;
		},
		setContatosTelefone(state, payload) {
			state.venda.contatos.telefone = payload;
		},
		setContatosCelular(state, payload) {
			state.venda.contatos.celular = payload;
		},
		setContatosCelular2(state, payload) {
			state.venda.contatos.celular_2 = payload;
		},
		setContatosDonoCelular2(state, payload) {
			state.venda.contatos.dono_celular_2 = payload;
		},
		setContatosEmail(state, payload) {
			state.venda.contatos.email = payload;
		},

		// ENDEREÇO
		setEnderecoCep(state, payload) {
			state.venda.endereco.cep = payload;
		},
		setEnderecoRua(state, payload) {
			state.venda.endereco.rua = payload;
		},
		setEnderecoNumero(state, payload) {
			state.venda.endereco.numero = payload;
		},
		setEnderecoComplemento(state, payload) {
			state.venda.endereco.complemento = payload;
		},
		setEnderecoCidade(state, payload) {
			state.venda.endereco.cidade = payload;
		},
		setEnderecoBairro(state, payload) {
			state.venda.endereco.bairro = payload;
		},
		setEnderecoUf(state, payload) {
			state.venda.endereco.uf = payload;
		},

		// ASSOCIADOS

		addAssociado(state, payload) {
			state.venda.associados.push(payload);
		},
		deleteAssociado(state, payload) {
			state.venda.associados = state.venda.associados.filter(itens => itens !== payload);
		},

		//DOCUMENTOS

		deleteDocumentos(state, payload) {
			state.venda.documentos = state.venda.documentos.filter(itens => itens !== payload);
		},
		addDocumentos(state, payload) {
			state.venda.documentos.push(payload);
		},
		deleteDocumentosAntigos(state, payload) {
			state.venda.listaDocumentosApagar.push(payload);
		},

		// FORMA DE PAGAMENTO MENSAL

		setPagamento(state, payload) {
			state.venda.forma_pagamento = payload;
		},
		setCardInfo(state, payload) {
			state.venda.card = payload;
		},

		// pagamento de adesão

		setFormaPagamentoAdesao(state, payload) {
			state.venda.forma_pagamento_adesao = payload;
		},
		setValorAdesao(state, payload) {
			state.venda.valor_adesao = payload;
		},
		setIsentoAdesao(state, payload) {
			state.venda.isento_adesao = payload;
		},
		setIsCpfValid(state, payload) {
			state.venda.isCpfValid = payload;
		},

		//ASSINATURA DIGITAL (NÃO UTILIZADA MAIS)
		setAssinatura(state, payload) {
			state.venda.assinatura = payload;
		},
		setAssinaturaAnexada(state, payload) {
			state.venda.assinaturaAnexada = payload;
		},

		// VALIDATIONS
		setDadosContratanteValid(state, payload) {
			state.venda.validations.DadosContratanteValid = payload;
		},
		setContatosValid(state, payload) {
			state.venda.validations.ContatosValid = payload;
		},
		setEnderecoValid(state, payload) {
			state.venda.validations.EnderecoValid = payload;
		},
		setPagamentoAdesaoValid(state, payload) {
			state.venda.validations.PagamentoAdesaoValid = payload;
		},
		setPagamentoValid(state, payload) {
			state.venda.validations.PagamentoValid = payload;
		},
		setCreditCardValidated(state, payload) {
			state.venda.validations.CreditCardValidated = payload;
		},
		setDocumentosValid(state, payload) {
			state.venda.validations.DocumentosValid = payload;
		},
		setIsAssociadosValid(state, payload) {
			state.venda.validations.AssociadoValid = payload;
		}
	},

	actions: {
		criarNovaVenda: (context, payload) => {
			context.commit("setVendedorId", payload.vendedorId);
			context.commit("setProdutoId", payload.produtoId);
			context.commit("setPlanoId", payload.planoId);
			context.commit("setVendedorNome", payload.vendedorNome);
			context.commit("setProdutoNome", payload.produtoNome);
			context.commit("setPlanoNome", payload.planoNome);
			context.commit("setContratanteAssociado", payload.contratanteAssociado);
		}
	},

	getters: {
		DadosContratanteValid(state) {
			return state.venda.validations.DadosContratanteValid;
		},
		ContatosValid(state) {
			return state.venda.validations.ContatosValid;
		},
		EnderecoValid(state) {
			return state.venda.validations.EnderecoValid;
		},
		PagamentoAdesaoValid(state) {
			return state.venda.validations.PagamentoAdesaoValid;
		},
		PagamentoValid(state) {
			return state.venda.validations.PagamentoValid;
		},
		DocumentosValid(state) {
			return state.venda.validations.DocumentosValid;
		},
		CreditCardValidated(state) {
			return state.venda.validations.CreditCardValidated;
		},
		AssociadoValid(state) {
			return state.venda.validations.AssociadoValid;
		}
	}
};
